const ufeApi = require('services/api/ufeApi');


// https://confluence.sephora.com/wiki/display/ILLUMINATE/Switch+Preferred+Store+API


function switchPreferredStore(preferredStoreId, customerSelected) {
    const url = '/api/users/profile/preferredStore';
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify({
            preferredStoreId: preferredStoreId,
            customerSelected: customerSelected
        })
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = switchPreferredStore;
